function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.22 0a1.14 1.14 0 00-.8.33L.33 9.42a1.11 1.11 0 000 1.58l.67.67a1.11 1.11 0 001.58 0L10.22 4l7.63 7.67a1.13 1.13 0 001.58 0l.67-.67a1.11 1.11 0 000-1.58L11 .33a1.11 1.11 0 00-.78-.33z"
});

function SvgChevronUp(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20.43 12"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/chevron-up.8f900419.svg";
export { SvgChevronUp as ReactComponent };